import { useMutation, useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';

const getContactSocials = async (ID) => {
    const socials = await Axios.get(`/contacts/socials/${ID}`);
    return socials;
};

const useContactSocials = (ID) => {
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['contactsocials', intID],
        queryFn: () => getContactSocials(intID),
        enabled: !disableQuery,
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadContactSocials = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['contactsocials', intID] });
};

const onUpdateSocials = (ID) => {
    forceReloadContactSocials(ID);
    forceReloadContact(ID);
};

const addContactSocial = ({ data, ContactID }) => Axios.post(`/socials`, data);

const useAddContactSocial = () => {
    return useMutation({
        mutationFn: addContactSocial,
        onSuccess: (data, variables) => {
            onUpdateSocials(variables.ContactID);
        },
    });
};

const removeContactSocial = async ({ ID, ContactID }) => Axios.delete(`/socials/${ID}`);

const useRemoveContactSocial = () => {
    return useMutation({
        mutationFn: removeContactSocial,
        onSuccess: (data, variables) => {
            onUpdateSocials(variables.ContactID);
        },
    });
};

const editContactSocial = async ({ data, ContactID }) => Axios.put(`/socials`, data);

const useEditContactSocial = () => {
    return useMutation({
        mutationFn: editContactSocial,
        onSuccess: (data, variables) => {
            onUpdateSocials(variables.ContactID);
        },
    });
};

export {
    useContactSocials,
    forceReloadContactSocials,
    useEditContactSocial,
    useRemoveContactSocial,
    useAddContactSocial,
};
